<div class="label label_required pt-2">{{ label }}</div>
<div class="field-wrapper">
  <ng-content></ng-content>
</div>
